var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 157,
    height: 97,
    viewBox: "0 0 157 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.590088 48.5C7.91356 34.1345 19.0662 22.0735 32.8156 13.6499C46.5649 5.22633 62.3755 0.768188 78.5001 0.768188C94.6246 0.768188 110.435 5.22633 124.185 13.6499C137.934 22.0735 149.087 34.1345 156.41 48.5C149.087 62.8655 137.934 74.9265 124.185 83.3501C110.435 91.7737 94.6246 96.2318 78.5001 96.2318C62.3755 96.2318 46.5649 91.7737 32.8156 83.3501C19.0662 74.9265 7.91356 62.8655 0.590088 48.5ZM78.5001 80.3C86.934 80.3 95.0224 76.9497 100.986 70.986C106.95 65.0223 110.3 56.9339 110.3 48.5C110.3 40.0661 106.95 31.9777 100.986 26.014C95.0224 20.0503 86.934 16.7 78.5001 16.7C70.0662 16.7 61.9778 20.0503 56.0141 26.014C50.0504 31.9777 46.7001 40.0661 46.7001 48.5C46.7001 56.9339 50.0504 65.0223 56.0141 70.986C61.9778 76.9497 70.0662 80.3 78.5001 80.3ZM78.5001 64.4C74.2831 64.4 70.2389 62.7248 67.2571 59.743C64.2753 56.7612 62.6001 52.7169 62.6001 48.5C62.6001 44.2831 64.2753 40.2388 67.2571 37.257C70.2389 34.2752 74.2831 32.6 78.5001 32.6C82.717 32.6 86.7613 34.2752 89.7431 37.257C92.7249 40.2388 94.4001 44.2831 94.4001 48.5C94.4001 52.7169 92.7249 56.7612 89.7431 59.743C86.7613 62.7248 82.717 64.4 78.5001 64.4Z",
    fill: "#0C7CEB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/View.3aa089e29157a00e9f70b3a7c9cbab6f.svg";
export { ForwardRef as ReactComponent };